import GroupForm from '../../GroupForm'
import useAddGroupHandler from '../../../effects/add-group'
import { heapEvent } from '@equipmentshare/heaper'

export type AddGroupModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export default function AddGroupModal( { onCancel, onSuccess }: AddGroupModalProps ) {
	const addGroup = useAddGroupHandler()
	const handleSubmit = async( name: string, spendingLimit?: string ) => {
		heapEvent( 'Inventory - Add Group Modal - Click - Save', {} )
		return await addGroup( name, spendingLimit )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Group Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<GroupForm
			onCancel={handleCancel}
			onSuccess={onSuccess}
			onSubmit={handleSubmit}
		/>
	)
}
